import React, { Component } from "react";
import { graphql, compose } from "react-apollo";
import { observer } from "mobx-react";
import { queryGetEmailCampaignAudienceMember } from "Apollo";
import LoadingPanel from "module-common/LoadingPanel";
import List from './member/List'
import styled, { css } from 'styled-components'
import Button from "module-common/Button";
import AddMember from "./member/AddMember";
import UploadContact from "./member/UploadContactWithMutation";

export default compose(
    graphql(queryGetEmailCampaignAudienceMember, {
      name: 'members',
      fetchPolicy: 'network-only'
    })
)(
    observer(
        class ListView extends Component {  
            state = {
                isCreatingMember: false
            }

            toggleCreateMember = (toggleValue) => {
                this.setState(state => ({...state, isCreatingMember: !!toggleValue}))
            }

            render() {
                const { members: { loading, getAudienceMember }, audienceId, accountId } = this.props;
                const { isCreatingMember } = this.state
                return (
                <React.Fragment>
                    <CreateMemberPanel>
                        <UploadContact audienceId={audienceId} accountId={accountId} />
                        {/* <Button
                            color="blue"
                            size="large"
                            border
                            onClick={() => this.toggleCreateMember(!isCreatingMember)}
                        >
                            {isCreatingMember ? 'Cancel' : 'Add Contact'}
                        </Button> */}
                    </CreateMemberPanel>
                    {isCreatingMember && <AddMember />}
                    {loading && <LoadingPanel />}
                    {!loading && getAudienceMember && !isCreatingMember && <List members={getAudienceMember} /> }                
                </React.Fragment>
                );
            }
        }
    )
);

const CreateMemberPanel = styled.div`
  height: 50px;
  width: 100%;
  padding: 10px 20px;
  display: flex;
  flex-direction: row-reverse;
  border-bottom: 1px solid #d2d3d5;
`
  


// WEBPACK FOOTER //
// ./src/module-email-campaign/audience/MemberListWithQuery.js